import React, { useEffect, useContext, useRef,useState } from 'react';
import { Form, Row, Col, message, Modal } from 'antd';
import {
  LayoutWithoutAuth,
  Input,
  Button,
  Typography,
  Countdown,
} from 'components';
import { useHistory, useParams } from 'react-router-dom';
import './login.less';
import * as loginService from 'services/login.service';
import { customMessages } from 'utils';
import { useDispatch, useSelector } from 'react-redux';
const { Title } = Typography;

const ApplySmsCodePage = () => {
  
  let history = useHistory();
  let { gsmNumber, mainNumber } = useParams();
  const dispatch = useDispatch();
  
  const auth = useSelector(state => state.auth);

  const [otpCounterStarted, setOtpCounterStarted] = useState(false);


  function sendOtp(data) {
    loginService
      .sendOtp(data)
      .then((result) => {
        setOtpCounterStarted(true);
      })
      .catch((response) => {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(response.responseCode),
        });
        history.push( `/Login`);
      });
  }

  function checkOtp(values) {
    let data = values;
    data.preToken = auth.preToken;
    data.msisdn = mainNumber;
    loginService
      .validateLoginOtp(values)
      .then((res) => {
        dispatch({
          type: 'LOGIN',
          payload: res,
        });
        history.push({
          pathname: `/Messages`,
        });
      })
      .catch((response) => {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(response.responseCode),
        });
      });
  }

 function submitForm(values) {
    if (otpCounterStarted)
    {
      checkOtp(values);
    }
    else{
      sendOtp({
        otpMsisdn: gsmNumber,
        msisdn: mainNumber,
        newUser: false,
        preToken: auth.preToken,
      });
    }
 }

 

  useEffect(() => {
    sendOtp({
      otpMsisdn: gsmNumber,
      msisdn: mainNumber,
      newUser: false,
      preToken: auth.preToken,
    });
    
  }, []);

  return (
    <LayoutWithoutAuth className="signup">
      <Row justify="center">
        <Col xs={24} s={24} md={16} lg={12} xl={10} xxl={10}>
          <Row justify="center" className="signup-box">
            <Col span={24} className="flex-center-center">
              <h1 className="section__title">Giriş Yap</h1>
            </Col>
            <Col
              span={24}
              className="flex-center-center margin-bottom-spacing-s"
            >
              <p className="info-text">
                <strong>{gsmNumber}</strong> numaralı telefonunuza gelen doğruluma kodunu giriniz.

              </p>
            </Col>
            <Col
              span={24}
              className="flex-center-center margin-bottom-spacing-s"
            >
               {<Countdown changedCounter={setOtpCounterStarted} startCounter={otpCounterStarted} />}
            </Col>
            <Form
              style={{ width: '100%' }}
              name="forgotPassword"
              onFinish={(values) => {
                submitForm(values);
              }}
              onFinishFailed={(event) =>
                console.log(
                  'onFinishFailed applySmsCode-signup form ==> ',
                  event
                )
              }
            >
              <Form.Item name="otp">
                <Input autoComplete="off" style={{ width: '100%' }} 
                        maxLength={6}/>
              </Form.Item>
              <Form.Item>
                <Form.Item>
                  <Row justify="center" gutter={30}>
                    <Col span={12}>
                      <Button
                        type="ghost"
                        onClick={() => history.push( `/Login/${gsmNumber}`)}
                      >
                        Önceki Adım
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button type="primary" htmlType="submit" shape="round">
                       {otpCounterStarted ? 'Doğrula':'Tekrar Gönder'} 
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </Form.Item>
            </Form>
          </Row>
        </Col>
      </Row>
      <Row justify="center">
        <Col xs={24} s={24} md={16} lg={12} xl={10} xxl={10}>
          <Row justify="center">
            <Title level={3}>Üyeliğiniz Yok mu?</Title>
          </Row>
          <Row justify="center" className="margin-bottom-spacing-xxl-4">
            <Button
              type="ghost"
              style={{ width: 180 }}
              onClick={() => history.push('/SignUp')}
            >
              Üye Ol
            </Button>
          </Row>
        </Col>
      </Row>
    </LayoutWithoutAuth>
  );
};
export default ApplySmsCodePage;
